
$(document).ready(function(e){
	if ($(document).find('.button--confirmation').length > 0){
		$(document).on('click tap', function(e){

			var target = $(e.target);
			var confirmation_button_clicked = null;

			if (target.hasClass('button--confirmation')){
				confirmation_button_clicked = target;
			} else if (target.closest('.button--confirmation').length > 0){
				confirmation_button_clicked = target.closest('.button--confirmation');
			}

			if (confirmation_button_clicked){

				// Second click, to confirm action
				if (confirmation_button_clicked.hasClass('button--confirmation--confirming')){

					// Do nothing. By default the button will work like any other link

				// First click
				} else {
					e.preventDefault();
					confirmation_button_clicked.addClass('button--confirmation--confirming');
				}
			} else {
				$(document).find('.button--confirmation--confirming').removeClass('button--confirmation--confirming');
			}
		});
	}
});